<lcs-loading-overlay
   class="flex-dir-col"
   [show]="callState | lcsCallState : 'loading'"
   *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'Role'"
>
   <div class="detail-page-headerbar">
      <div class="left">
         <div class="page-heading">
            <h2 class="page-title">Role - {{ role?.name }}</h2>
         </div>
      </div>
      <div class="right context-actions">
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="updateDetailsMenu"
            matTooltip="Info"
            aria-label="Prompt Info"
            id="extension-detail-info"
         >
            <mat-icon>info</mat-icon>
         </button>
         @if (rolePrivileges?.canDelete) {
         <button
            type="button"
            mat-button
            class="role-actions-button"
            [matMenuTriggerFor]="roleMenu"
            aria-label="User Actions"
            matTooltip="More Actions"
            id="role-detail-more-actions"
         >
            <mat-icon>more_horiz</mat-icon>
         </button>
         }
      </div>
   </div>
   <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <ndt-two-column-layout>
         <div ndtLeftColumn>
            <div class="details-wrapper">
               <ng-container>
                  <h5>Description</h5>
                  <div class="detail-item">{{ role?.description }}</div>
               </ng-container>
               <ng-container>
                  <h5>User Count</h5>
                  <div class="detail-item">{{ role?.userRolesConnection.totalCount }}</div>
               </ng-container>
            </div>
         </div>
         <div ndtRightColumn>
            <mat-tab-group
               class="detail-tab-group"
               [(selectedIndex)]="selectedIndex"
               ndt-tab-router
               [loadSuccess$]="loadSuccess$"
            >
               <mat-tab [label]="'Role'">
                  <div class="mat-tab-indented">
                     <div class="detail-right-column">
                        <mat-form-field class="flex-full">
                           <mat-label>Name</mat-label>
                           <input matInput autocomplete="off" type="text" formControlName="name" [value]="role?.name" />
                           @if (form.get('name')?.hasError('required')) {
                           <mat-error> Name is Required. </mat-error>
                           } @if (form.get('name')?.hasError('maxlength')) {
                           <mat-error> Name must be less than 50 characters </mat-error>
                           } @if (!form.get('name')?.hasError('required') && form.get('name')?.hasError('noContent')) {
                           <mat-error>Name must contain characters.</mat-error>
                           }
                        </mat-form-field>
                        <mat-form-field class="flex-full">
                           <mat-label>Description</mat-label>
                           <input
                              matInput
                              autocomplete="off"
                              type="text"
                              formControlName="description"
                              [value]="role?.description"
                           />
                           @if (form.get('description')?.hasError('maxlength')) {
                           <mat-error> Description must be less than 255 characters </mat-error>
                           }
                        </mat-form-field>
                     </div>
                  </div>
               </mat-tab>
               <mat-tab [label]="'Privileges'"
                  >@if (privileges) {
                  <div class="mat-tab-indented role-privilege-tab"
                     ><ndt-privileges-list
                        [privileges]="privileges"
                        formGroupName="rolePrivileges"
                        [isOnSystemPage]="isOnSystemPage"
                     ></ndt-privileges-list>
                  </div>
                  }</mat-tab
               >
               <mat-tab [label]="'Reports'">
                  <div class="mat-tab-indented">
                     <div class="detail-right-column">
                        <ng-template matTabContent>
                           <ndt-report-permissions-list-view
                              [name]="'reports'"
                              [roleReports]="role?.roleReports"
                              [isOnSystemPage]="isOnSystemPage"
                              formControlName="roleReports"
                              (reportsChange)="handleReportsChange($event)"
                           ></ndt-report-permissions-list-view>
                        </ng-template>
                     </div>
                  </div>
               </mat-tab>
               @if(!isOnSystemPage){
               <mat-tab [label]="'Recordings'">
                  <div class="mat-tab-indented recording-permission-tab-body">
                     <ndt-call-recording-extensions-list
                        formControlName="roleRecordingExtensions"
                        [extensions]="extensions"
                        [extensionGroups]="extensionGroups"
                     ></ndt-call-recording-extensions-list>
                  </div>
               </mat-tab>
               }
               <mat-tab [label]="'Users'">
                  <div class="mat-tab-indented">
                     @if (role?.userRolesConnection) {
                     <ndt-role-user-register
                        [userIds]="role?.userRolesConnection['items']"
                        [isOnSystemPage]="isOnSystemPage"
                     ></ndt-role-user-register>
                     }
                  </div>
               </mat-tab>
            </mat-tab-group>
         </div>
      </ndt-two-column-layout>
      <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
   </form>
</lcs-loading-overlay>
<mat-menu #roleMenu="matMenu">
   @if (rolePrivileges?.canDelete) {
   <button mat-menu-item type="button" (click)="onDeleteClick()" id="menu-role-delete"> Delete </button>
   }
</mat-menu>
<mat-menu #updateDetailsMenu="matMenu">
   <update-details
      [createUser]="role?.createUser"
      [createDate]="role?.createDate"
      [updateUser]="role?.updateUser"
      [updateDate]="role?.updateDate"
   ></update-details>
</mat-menu>
